module.exports = __webpack_public_path__ + "img/facebook.a85afcbd.svg";